export enum StudentQueryKeys {
    BADGES = 'badges',
    LEARNING_OBJECTIVES = 'learningObjectives',
    SLIDES = 'slides',
}
